import {AnticipatorView, ComponentsConfigs, getCommonFixedScreenSizeModules} from '@gongxigames/framework/slot';
import {PremonitionModule} from 'src/premonition/PremonitionModule';
import {PremonitionView} from 'src/premonition/PremonitionView';
import {GameReelsModule} from 'src/gameReels/GameReelsModule';
/* develblock:start */
import {GameCheatModule} from 'src/gameCheatPage/GameCheatModule';
/* develblock:end */
import {GameReelsView} from 'src/gameReels/GameReelsView';
import {GameWinPresentationView} from 'src/winPresentation/GameWinPresentationView';
import {GameWinPresentationUtils} from 'src/winPresentation/GameWinPresentationUtils';
import {GameFlowModule} from 'src/win/GameFlowModule';
import {GameBigWinView} from 'src/bigwin/GameBigWinView';
import {GameBackgroundModule} from 'src/gameBackground/GameBackgroundModule';
import {GameBackgroundView} from 'src/gameBackground/GameBackgroundView';
import {RandomWildModule} from 'src/randomWild/RandomWildModule';
import {RandomWildView} from 'src/randomWild/RandomWildView';
import {PickBonusModule} from 'src/pickBonus/PickBonusModule';
import {PickBonusView} from 'src/pickBonus/PickBonusView';
import {RubyGameRules} from 'src/gameRules/RubyGameRules';
import {RubyInfoPage} from 'src/infoPage/RubyInfoPage';
import {GameKeypadInfoElementsModule} from 'src/keypad/info/GameKeypadInfoElementsModule';
import {GameWinPresentationModule} from 'src/winPresentation/GameWinPresentationModule';
import {GameKeypadControlsModule} from 'src/keypad/controls/GameKeypadControlsModule';
import {GameFreeSpinsModule} from 'src/freespins/GameFreeSpinsModule';
import {GameAnticipatorModule} from 'src/gameAnticipator/GameAnticipatorModule';
import {GameCoinFlightModule} from 'src/buyBonus/coinFlight/GameCoinFlightModule';
import {GameCoinFlightView} from 'src/buyBonus/coinFlight/GameCoinFlightView';
import {GameGenericPopupModule} from 'src/gameGenericPopup/GameGenericPopupModule';
import {GameLogic} from 'src/server/GameLogic';

export const componentsConfig: ComponentsConfigs = {
    services: [
        GameLogic,
        GameWinPresentationUtils
    ],
    modules: [
        ...getCommonFixedScreenSizeModules().modules,
        GameAnticipatorModule,
        GameReelsModule,
        GameKeypadControlsModule,
        GameKeypadInfoElementsModule,
        /* develblock:start */
        GameCheatModule,
        /* develblock:end */
        GameBackgroundModule,
        GameWinPresentationModule,
        RubyGameRules,
        RubyInfoPage,
        PremonitionModule,
        GameFlowModule,
        RandomWildModule,
        PickBonusModule,
        GameCoinFlightModule,
        GameFreeSpinsModule,
        GameGenericPopupModule
    ],
    views: [
        ...getCommonFixedScreenSizeModules().views,
        GameWinPresentationView,
        GameReelsView,
        GameBackgroundView,
        PremonitionView,
        GameBigWinView,
        RandomWildView,
        PickBonusView,
        GameCoinFlightView,
        AnticipatorView
    ]
};
